import { createGlobalState } from 'react-use';

const useGlobalForecastFeedbackModalOpenState = createGlobalState<boolean>(false);
export const useForecastFeedbackModalOpenState = () => useGlobalForecastFeedbackModalOpenState();

const useGlobalForecastFeedbackFormSubmissionSuccess = createGlobalState<{
  status: boolean;
  data?: { linkHref?: string; message?: React.ReactNode | string };
}>({ status: false });
export const useForecastFeedbackFormSubmissionSuccess = () =>
  useGlobalForecastFeedbackFormSubmissionSuccess();

const globalVariables = {
  useForecastFeedbackModalOpenState,
  useForecastFeedbackFormSubmissionSuccess,
};

export default globalVariables;
